






import { defineComponent } from '@vue/composition-api';

import PanelWithMaterialPurchaseOrderEditor from '@/components/PurchaseOrder/PanelWithMaterialPurchaseOrderEditor.vue';

const CreateProduction = defineComponent({
  components: { PanelWithMaterialPurchaseOrderEditor },
  // setup() {},
});

export default CreateProduction;
